@if (!isDataInitialized) {
  <dcp-loading-page/>
} @else {
  <div class="udex-grid udex-mx-auto udex-pb-56 udex-pb-lg-84">
    @if (!hideCartContent) {
      <div class="row">
        <div class="col-12 col-lg-8">
          <dcp-disposable-message
            class="d-block">
          </dcp-disposable-message>
        </div>

        <div class="col-12 col-lg-8 udex-mb-32 udex-mb-56">
          @if (isCartOutdated() | async) {
            <dcp-outdated-cart-message
              class="d-block"
              [class.sticky-order-summary-margin-top]="isNeedToShowOutdatedCartMessage"
              [class.mb-3]="isVisibleDisposableBlock"
              [message]="outdatedCartMessage$ | async"
              [isShown]="isCartOutdated() | async">
            </dcp-outdated-cart-message>
          }

          @if (cartEntryGroups?.length) {
            <dcp-bundle-provided-by
              [entryGroups]="cartEntryGroups"
              [orderEntries$]="cartEntries$">
              <ng-template #providedOrderEntries let-context>
                <dcp-bundle-order-table
                  [collapsable]="context.collapsable"
                  [collapsed]="context.collapsed"
                  [entry]="context.entry"
                  [isInvalid]="context.isInvalid"
                  [derivativeCount]="context.derivativeCount"
                  [showPrice]="true"
                  [showEditAction]="true"
                  [showRemoveAction]="true">
                </dcp-bundle-order-table>
              </ng-template>
              <ng-template #derivatives let-context>
                <dcp-additional-required-solutions-button
                  [derivativeCount]="context.derivativeCount"
                  [providerContract]="context.providerContract">
                </dcp-additional-required-solutions-button>
              </ng-template>
              <ng-template #groupTotal let-context>
                <dcp-group-total
                  [checkout$]="cart$"
                  [providerContract]="context.providerContract">
                </dcp-group-total>
              </ng-template>
              <ng-template #recurringTotal let-context>
                <dcp-recurring-total
                  [checkout$]="cart$"
                  [providerContract]="context.providerContract">
                </dcp-recurring-total>
              </ng-template>
              <ng-template #termsAndConditions let-context>
                <dcp-terms-conditions
                  [removalStatus]="context.removalStatus"
                  [entry]="context.entry"
                  [entries]="context.entries">
                </dcp-terms-conditions>
              </ng-template>
            </dcp-bundle-provided-by>
          } @else {
            <dcp-provided-by [orderEntries$]="cartEntries$">
              <ng-template #providedOrderEntries let-context>
                <dcp-order-table
                  [entries]="cartEntries$ | async "
                  [entryCount]="context.entryCount"
                  [entry]="context.entry"
                  [showPrice]="true"
                  [showEditAction]="true"
                  [showRemoveAction]="true">
                </dcp-order-table>
              </ng-template>
            </dcp-provided-by>
          }
        </div>

        <div class="col-12 col-lg-4">
          <dcp-summary
            class="d-block sticky-order-summary-margin-top"
            [selectedView]="view.Cart">
          </dcp-summary>
        </div>
      </div>
    }
  </div>
}

@if (cart$ | async; as cart) {
  <dcp-invalid-cart-entry-message
    (indicatorChange)="showIndicator($event)"
    [cart]="cart">
  </dcp-invalid-cart-entry-message>
}

<dcp-configure-service-error
  (configureServiceError)="hideCartContent = $event">
</dcp-configure-service-error>
